import { Series } from "../series"

/**
 * @constructor
 * @augments Tee.Series
 * @class plots a LinearGauge.
 * @property {Number} increment default 20 sets label increment
 * @property {String} markSymbol defaulr '%'
 * @property {string[]} gradientColors default ['red','green']
 * @property {Number} animationIncrement default 1;
 * @property {Number} startValue sets startvalue for animated bar
 * @property {Number} finalValue sets startvalue for animated bar
 */
let LinearGauge = function (o, o2) {
	Series.call(this, o, o2)

	var f = this.format
	f.stroke.fill = "black"
	f.stroke.size = 1
	f.font.style = "16px Arial"
	this.lineFill = "#000"
	this.txtHeight = f.textHeight("Wj")
	this.min = 0
	this.max = 100
	this.increment = 20
	this.markSymbol = "%"
	this.gradientColors = ["red", "green"]
	this.animationIncrement = 1

	this.startValue = o == undefined ? 0 : o
	this.finalValue = o2 == undefined ? 0 : o2
	this.value = this.startValue

	this.useAxes = false

	this.drawAll = function (value, ctx, gaugeX, gaugeY, gradient, gaugeWidth, gaugeHeight) {
		this.drawBar(value, ctx, gaugeX, gaugeY, gradient, gaugeWidth, gaugeHeight, true)
	}

	this.drawBar = function (value, ctx, gaugeX, gaugeY, gradient, gaugeWidth, gaugeHeight, first) {
		this.value = value

		for (let i = this.min; i <= this.max; i += this.increment) {
			const x = this.gaugeX + (this.gaugeWidth * i) / 100
			ctx.fillStyle = this.lineFill
			ctx.lineWidth = f.stroke.size
			ctx.moveTo(x, gaugeY - 5)
			ctx.lineTo(x, gaugeY + this.gaugeHeight + 5)
			//ctx.fillRect(x, gaugeY - 5, 1, this.gaugeHeight + 10);
			ctx.stroke()
			if (first) {
				ctx.font = this.chart.axes.bottom.labels.format.font.style
				var ltext = `${i}` + this.markSymbol
				ctx.fillText(ltext, x - f.textWidth(ltext) / 2, gaugeY - this.txtHeight)
				var ltext = ""
			}
		}

		ctx.fillStyle = gradient
		ctx.fillRect(this.gaugeX, gaugeY, this.gaugeWidth * (value / 100), this.gaugeHeight)

		//mark
		if (this.marks.visible) {
			ctx.fillStyle = this.marks.format.font.fill
			ctx.font = this.marks.format.font.style
			ctx.fillText(
				this.value,
				this.gaugeWidth * (value / 100) + 12,
				gaugeY + this.gaugeHeight / 2 - this.marks.format.textHeight("Wj") / 2
			)
		}

		ctx.strokeStyle = f.stroke.fill
		ctx.lineWidth = f.stroke.size
		ctx.strokeRect(this.gaugeX, gaugeY, this.gaugeWidth, this.gaugeHeight)
	}

	this.animateGauge = function (
		currentValue,
		targetValue,
		gradient,
		gaugeX,
		gaugeY,
		gaugeWidth,
		gaugeHeight,
		ctx,
		first
	) {
		if (currentValue != targetValue) {
			if (Math.abs(currentValue - targetValue) <= this.animationIncrement) currentValue = targetValue
			else if (currentValue < targetValue) currentValue += this.animationIncrement
			else currentValue -= this.animationIncrement

			if (first) this.drawAll(currentValue, ctx, this.gaugeX, gaugeY, gradient, this.gaugeWidth, this.gaugeHeight)
			else {
				ctx.clearRect(this.gaugeX, gaugeY, this.gaugeWidth, this.gaugeHeight)
				this.drawBar(currentValue, ctx, this.gaugeX, gaugeY, gradient, this.gaugeWidth, this.gaugeHeight, false)
			}
			requestAnimationFrame(() =>
				this.animateGauge(currentValue, targetValue, gradient, gaugeX, gaugeY, gaugeWidth, gaugeHeight, ctx, false)
			)
		}
		//else
		//  this.drawAll(currentValue, ctx, this.gaugeX, gaugeY,gradient,this.gaugeWidth,this.gaugeHeight);
	}

	this.draw = function () {
		var value = this.startValue
		var ctx = this.chart.ctx
		var height = this.chart.chartRect.height
		var width = this.chart.chartRect.width
		this.gaugeWidth = width - 20
		this.gaugeHeight = 30
		this.gaugeX = 30 //leave space for 1st label.
		var gaugeY = (height - this.gaugeHeight) / 2

		const gradient = ctx.createLinearGradient(0, 0, this.gaugeWidth, 0)
		gradient.addColorStop(0, this.gradientColors[0])
		gradient.addColorStop(1, this.gradientColors[1])

		if (this.animation == true) {
			const currentValue = value
			const targetValue = this.finalValue
			if (currentValue == targetValue)
				this.drawAll(o2, ctx, this.gaugeX, gaugeY, gradient, this.gaugeWidth, this.gaugeHeight)
			else
				this.animateGauge(
					currentValue,
					targetValue,
					gradient,
					this.gaugeX,
					gaugeY,
					this.gaugeWidth,
					this.gaugeHeight,
					ctx,
					true
				)
		} else {
			this.drawAll(o2, ctx, this.gaugeX, gaugeY, gradient, this.gaugeWidth, this.gaugeHeight)
		}
	}
}

LinearGauge.prototype = new Series()

export { LinearGauge }
